"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Selector = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _selectors = require("../../../redux/selectors");
var _constants = require("../../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  colors
} = _paulCorePackage.constants;

/** @todo remove important */
const hideSX = {
  opacity: 0,
  pointerEvents: 'none !important',
  position: 'absolute'
};
const Selector = exports.Selector = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    item = {},
    value,
    setValue,
    options,
    helperText
  } = _ref;
  const theme = (0, _reactRedux.useSelector)(_selectors.getPackageTheme);
  const updateSelector = (0, _react.useCallback)((_, v) => {
    setValue(v);
  }, [setValue]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: _objectSpread({
      transition: _constants.styles.transitionType.primary,
      '& > div': {
        width: '100%'
      }
    }, options.length < 2 ? hideSX : {})
  }, /*#__PURE__*/_react.default.createElement(_paulCorePackage.Select, {
    value: value,
    updateSelector: updateSelector,
    borderBottomColor: theme === _paulCorePackage.constants.themeKey.dark ? colors['main-color-cl-31'] : null,
    theme: theme,
    item: item,
    options: options,
    variant: "secondary"
  }), /*#__PURE__*/_react.default.createElement(_material.FormHelperText, {
    sx: {
      color: theme === _paulCorePackage.constants.themeKey.dark ? colors['main-color-cl-09'] : 'currentColor'
    }
  }, helperText !== null && helperText !== void 0 ? helperText : /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    variant: "text",
    width: 80,
    sx: {
      fontSize: 'inherit'
    }
  })));
}, function () {
  let prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return prev.item === next.item && prev.value === next.value && prev.setValue === next.setValue && prev.options === next.options && prev.helperText === next.helperText;
});
Selector.propTypes = {
  helperText: _propTypes.default.string,
  item: _propTypes.default.shape({
    defaultValue: _propTypes.default.string,
    type: _propTypes.default.string,
    name: _propTypes.default.string
  }),
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    value: _propTypes.default.string,
    label: _propTypes.default.string
  })),
  value: _propTypes.default.string,
  setValue: _propTypes.default.func
};